<template>
  <b-modal size="lg" v-model="showForm" :title="formTitle + ' ghép cặp Bác sỹ - Tình nguyện viên'" @ok="save" no-close-on-backdrop no-enforce-focus>
    <div class="row">
      <div class="col-md">
        <user-group-select-form :model="formModel" attribute="group" :errors="formErrors" label="Chọn nhóm"
                                v-if="$store.state.user.permissions.includes('userManageAll')">
        </user-group-select-form>
        <user-select :model="formModel" :group-filter="formModel.group" :roles-filter="['bac-sy', 'bac-sy-pho-nhom']" attribute="doctorUser" :errors="formErrors" label="Chọn bác sỹ"></user-select>
        <user-select :model="formModel" :group-filter="formModel.group" role-filter="nvyt" attribute="followUsers" multiple :errors="formErrors" label="Chọn tình nguyện viên"></user-select>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
      </b-button>
      <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
        <b-spinner v-if="saveLoading" small></b-spinner>
        {{ $t('save') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import crud from '@/mixins/CRUD';
import UserSelect from "@/components/UserSelect";
import UserGroupSelectForm from '@/components/UserGroupSelectForm.vue';
export default {
  name: "NhomNVYTModal",
  components: {
    UserSelect,
    UserGroupSelectForm,
  },
  mixins: [crud],
  data: function () {
    return {
      service: "/nhom-nvyt",
      autoLoad: true,
      reloadBus: 'reloadNhomBacSy',
      defaultFormModel: {
        group: this.$store.state.user.permissions.includes('userManageGroup') && !this.$store.state.user.permissions.includes('userManageAll')
            ? this.$store.state.user.group
            : null,
      },
    };
  },
  methods: {
    createNhomNVYT(group, doctorUser) {
      this.defaultFormModel = {
        group: group,
        doctorUser: doctorUser
      }
      this.create();
    },
    save: function (evt) {
      if(evt) {
        evt.preventDefault();
      }
      this.saveLoading = true;
      let method = 'post';
      let url = this.service;
      if (this.formModel.id) {
        method = 'put';
        url += '/' + this.formModel.id;
      }
      return this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showForm = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('reloadInternalContact');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
        return response.data;
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    },
  }
}
</script>

<style scoped>

</style>